import { CreditCard, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink, EMI_WA_TEXT } from "../../lib/constants";
import { track } from "../../lib/tracking";

export const EMI = () => (
  <section data-testid="emi-section" className="py-24 md:py-32">
    <div className="max-w-5xl mx-auto px-5 md:px-10 text-center">
      <Reveal>
        <span className="inline-flex items-center gap-2 rounded-full border border-champagne px-5 py-2 font-mono text-[0.65rem] uppercase tracking-[0.3em] text-teal/70">
          <CreditCard className="w-3.5 h-3.5" strokeWidth={1.6} />
          Flexible Payment
        </span>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="mt-8 font-display text-3xl md:text-5xl font-light tracking-tight text-ink leading-tight">
          Want to Start Without Paying the Full Amount Upfront?
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <p data-testid="emi-headline" className="mt-8 font-mono text-2xl md:text-4xl tracking-[0.12em] text-teal font-medium">
          NO-COST EMI AVAILABLE
        </p>
        <p className="mt-5 text-base font-light text-ink/60 max-w-xl mx-auto leading-relaxed">
          Ask our team about available no-cost EMI options for eligible patients.
        </p>
      </Reveal>
      <Reveal delay={0.24}>
        <a
          href={waLink(EMI_WA_TEXT)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track("emi_click", { placement: "emi_section" })}
          data-testid="emi-check-button"
          className="group mt-10 inline-flex items-center gap-3 rounded-full border border-teal/35 px-9 py-4 text-sm font-bold uppercase tracking-[0.16em] text-teal transition-colors duration-300 hover:bg-teal hover:text-ivory"
        >
          Check EMI Options
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
        </a>
        <p className="mt-6 text-xs font-light text-ink/45">
          EMI availability depends on eligibility and payment method. Terms apply.
        </p>
      </Reveal>
    </div>
  </section>
);
